import { FEATURE_FLAGS } from '../../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from 'dashboard/helper/URLHelper';

import CustomRolesHome from './Index.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.CUSTOM_ROLES,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-roles'),
      meta,
      redirect: to => {
        return { name: 'custom_roles_list', params: to.params };
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/custom-roles/list'),
      name: 'custom_roles_list',
      meta,
      component: CustomRolesHome,
    },
  ],
};
